import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import AccountFundingBreakdown from './AccountFundingBreakdown';
import RequirementCompactRow from './RequirementCompactRow';

const sortRequirements = (reqs) =>
  [...reqs].sort((a, b) => {
    if (a.is_account_base !== b.is_account_base) {
      return a.is_account_base ? -1 : 1;
    }
    return a.name.localeCompare(b.name);
  });

const BankAccountRequirementDetail = ({
  allocations,
  bills,
  requirements,
  fortnightStart,
  fortnightEnd,
  fortnightIndex,
  showInactive,
  onShowInactiveChange,
  onEdit,
  onAdvancedGenerate,
  onViewBills,
  renderCategoryIcon,
}) => {
  const renderSection = (heading, items) => {
    if (!items.length) return null;
    return (
      <div className="requirements-bank-section">
        <h6 className="requirements-bank-section-title">
          <span>{heading}</span>
          <span className="requirements-bank-section-subtitle">Active this fortnight</span>
        </h6>
        <div className="requirements-compact-row-list">
          {items.map((req) => (
            <RequirementCompactRow
              key={req.id}
              req={req}
              fortnightStart={fortnightStart}
              fortnightEnd={fortnightEnd}
              fortnightIndex={fortnightIndex}
              showInactive={showInactive}
              onEdit={onEdit}
              onAdvancedGenerate={onAdvancedGenerate}
              onViewBills={onViewBills}
              categoryIcon={
                req.category_name && renderCategoryIcon
                  ? renderCategoryIcon(req.category_details?.icon, req.category_details?.color)
                  : null
              }
            />
          ))}
        </div>
      </div>
    );
  };

  if (!fortnightStart || !fortnightEnd) {
    return null;
  }

  return (
    <>
      <Form.Check
        type="switch"
        id={`show-inactive-${fortnightStart.getTime()}`}
        className="requirements-bank-show-inactive mb-2"
        label="Show inactive (this fortnight)"
        checked={showInactive}
        onChange={(e) => onShowInactiveChange(e.target.checked)}
      />
      <AccountFundingBreakdown
        requirements={requirements}
        fortnightStart={fortnightStart}
        fortnightEnd={fortnightEnd}
        defaultCollapsed
      />
      {renderSection('Allocations', allocations)}
      {renderSection('Bills', bills)}
      {!allocations.length && !bills.length && (
        <p className="text-muted small mb-0">No requirements for this account.</p>
      )}
    </>
  );
};

BankAccountRequirementDetail.propTypes = {
  allocations: PropTypes.arrayOf(PropTypes.object).isRequired,
  bills: PropTypes.arrayOf(PropTypes.object).isRequired,
  requirements: PropTypes.arrayOf(PropTypes.object).isRequired,
  fortnightStart: PropTypes.instanceOf(Date).isRequired,
  fortnightEnd: PropTypes.instanceOf(Date).isRequired,
  fortnightIndex: PropTypes.number.isRequired,
  showInactive: PropTypes.bool.isRequired,
  onShowInactiveChange: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onAdvancedGenerate: PropTypes.func.isRequired,
  onViewBills: PropTypes.func.isRequired,
  renderCategoryIcon: PropTypes.func,
};

export { sortRequirements };
export default BankAccountRequirementDetail;
